import { autoLcStoreWorkProcess } from '@/locales/ko/views/store_work_process';
const lc = autoLcStoreWorkProcess();
export const tableHeader = [
    {
        title: lc('table.id'),
        align: 'center',
        width: 100,
    },
    {
        title: lc('table.title'),
        align: 'center',
    },
    {
        title: lc('table.user_name'),
        align: 'center',
        width: 180,
    },
    {
        title: lc('table.created_time'),
        align: 'center',
        width: 180,
    },
];
export const searchTypeList = [
    {
        text: '제목',
        value: 'title',
    },
    {
        text: '제목1',
        value: 'title1',
    },
];
